import { useParams } from 'react-router-dom';

import { useLandingTenantId } from './lastAccessedTenant';

export const useTenantIdFromParams = () => {
  const { tenantId } = useParams() as { tenantId: string | undefined };
  return tenantId;
};

/**
 * Tenant resolution for components mounted under BOTH `:tenantId` routes and
 * tenantless routes (e.g. output-template pages, which render under
 * `/organizations/:tenantId/settings/templates` AND `/admin/output-templates`).
 *
 * Route tenant wins when present. Otherwise this resolves the same way the
 * tenantless redirects do — NOT off the shared session claim, which pins to
 * the login-time org and had these pages generating and publishing templates
 * against it after a switch [ENG-5785].
 */
export const useTenantIdFromParamsOrLanding = (): string | undefined => {
  const routeTenantId = useTenantIdFromParams();
  const landingTenantId = useLandingTenantId();
  return routeTenantId ?? landingTenantId;
};

/**
 * Assumes that there will definitely be a tenantId in the URL params.
 * This hook is safe to use if you know you're in a :tenantId route
 */
export const useAssignedTenantIdFromParams = () => {
  const { tenantId } = useParams() as { tenantId: string };
  return tenantId;
};
